
<template>
  <div class="question">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
<!--      <span class="icon"-->
<!--            @click="goHistory"><img class="goHistory"-->
<!--             src="../../assets/image/08.png"-->
<!--             alt=""></span>-->
<!--      <span class="iconText">已解决问题</span>-->
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
           <router-link :to="'/accompanyStudy/questionSolve'">待解决问题</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          已解决问题
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <div class="contMes">
        <div class="mesTop">
          <a-row>
            <a-col :span="6">
              <a-select default-value="全部文章" style="width: 260px" @change="handleBook">
                <a-select-option :value="item.id" v-for="(item, index) in bookList" :key="index">
                  {{item.orgDisplayName}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="15">
              <a-select default-value="全部班级" style="width: 160px" @change="handleClass">
                <a-select-option :value="item.id" v-for="(item, index) in classList" :key="index">
                  {{item.className}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="3" style="margin-left:auto;">
              <router-link :to="{name: 'QuestionToSolve',params: {id:styleId,hide:1}}">
                <div class="questionSolve">问题处理</div>
              </router-link>
            </a-col>
          </a-row>
        </div>
        <div class="mesList">
          <a-list item-layout="vertical"
                  size="large"
                  :data-source="listData">
            <a-list-item slot="renderItem" key="item.title" slot-scope="item">
              <a-list-item-meta :description="item.description">
                <div slot="title">
                  <div class="prepare">
                    <div class="bookName">{{item.lessonTitle}}</div>
                    <p class="bookTitle">{{item.textContent}}</p>
                    <a-row style="height:160px;overflow:hidden;">
                      <a-col :span="1">
                        <img class="photoImg"
                             v-if="item.userPhoto&&item.userPhoto!=null"
                             :src="$userINfoBasePath+'/'+item.userPhoto"
                             alt="" />
                        <img class="photoImg"
                             v-else
                             src="../../../src/assets/imgs/student.png"
                             alt="" />
                      </a-col>
                      <a-col :span="23">
                        <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo}}</span>
                        <p class="questionText">{{item.content}}</p>
                        <p class="date">{{format.formatDayTime(item.createDate)}}</p>
                        <div v-for="(d, index) in item.replyList"
                             :key="index">
                          <img class="photoImg"
                               v-if="d.userPhoto&&d.userPhoto!=null"
                               :src="$userINfoBasePath+'/'+d.userPhoto"
                               alt="" />
                          <img class="photoImg"
                               v-else
                               src="../../../src/assets/imgs/teacher.png"
                               alt="" />
                          <span class="userName">{{d.userName}}</span> <span class="fuhao">@</span><span class="userSchool">{{d.recuserName}}</span>
                          <p class="questionText">{{d.replyContent}}</p>
                          <p class="date">{{format.formatDayTime(d.createDate)}}</p>
                        </div>
                      </a-col>
                    </a-row>
                    <div class="forAsk"
                         @click="goLookAsk(item.id)"> 查看全部回答 </div>
                  </div>
                  <div class="askHelp">
                    <!-- <a-button class="help" @click="askForProfession()">求助专家</a-button> -->
                    <a-button class="ask"
                              @click="answer(item)">回答</a-button>
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
        <div style="text-align:center;margin-top:15px;">
          <a-config-provider>
            <a-pagination :default-current="1"
                          :page-size="pageSize"
                          @change="handleListChange"
                          :total='total' />
          </a-config-provider>
        </div>
      </div>
    </div>
    <a-modal v-model="lookMore"
             width="1100px"
             title="查看全部回答"
             footer="">
      <div class="mesMore">
        <div slot="title">
          <div class="prepare">
            <!-- <div class="bookName">{{lookMoreMes.lessonTitle}}</div>
            <p class="bookTitle">{{lookMoreMes.textContent}}</p> -->
            <a-row>
              <!-- <a-col :span="1">
                <img class="photoImg"
                     v-if="lookMoreMes.userPhoto"
                     :src="$userINfoBasePath+'/'+lookMoreMes.userPhoto"
                     alt="" />
              </a-col> -->
              <a-col :span="23">
                <!-- <span class="userName">{{lookMoreMes.userName}}</span><span class="userSchool">{{lookMoreMes.userClassInfo}}</span>
              <p class="questionText">{{lookMoreMes.content}}</p>
              <p class="date">{{format.formatDayTime(lookMoreMes.createDate)}}</p>
              <div v-for="(d, index) in lookMoreMes.replyList"
                   :key="index">
                <span class="userName">{{d.userName}}</span> <span class="fuhao">@</span><span class="userSchool">{{d.recuserName}}</span>
                <p class="questionText">{{d.replyContent}}</p>
                <p class="date">{{format.formatDayTime(d.createDate)}}</p>

              </div> -->
                <div v-for="(t,index) in lookMoreMes.replyList"
                     :key="'child'+index">
                  <img class="photoImg"
                       v-if="t.userPhoto&&t.userPhoto!=null"
                       :src="$userINfoBasePath+'/'+t.userPhoto"
                       alt="" />
                  <img class="photoImg"
                       v-else
                       src="../../../src/assets/imgs/teacher.png"
                       alt="" />
                  <span class="userName">{{t.userName}}</span>
                  <span class="fuhao">@</span><span class="userSchool">{{t.recuserName}}</span>
                  <p class="questionText">{{t.replyContent}}</p>
                  <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                </div>
                <!-- <div class="forAsk" @click="goLookAsk(item)"> 查看全部回答 </div> -->
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="askHelp">
        <a-button class="ask" @click="answer(lookMoreMes)">回答</a-button>
      </div>
    </a-modal>
    <!--回答弹窗-->
    <a-modal v-model="answerModal"
             width="1100px"
             title=""
             footer="">
      <div class="answerMes">
        <div><span class="answerText">回答</span><span class="answerName">{{answerMess.userName}}</span></div>
        <div class="answerTitle">{{answerMess.textContent}}</div>
        <div class="answerBgc">
          <a-textarea v-model="value" :auto-size="{ minRows: 6, maxRows: 10 }" />
        </div>
      </div>
      <div class="askHelp">
        <a-button class="ask" @click="teacherReplay(answerMess)">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import format from '../../utils/format.js'
export default {
  name: 'QuestionAchived',
  data () {
    return {
      format,
      resBasePath: this.$resBasePath,
      loading: true,
      lookMore: false,
      lookMoreMes: '', // 查看更多消息
      answerModal: false,
      answerMess: '',//
      allAnswer: '', // 产看全部回答详情
      askName: '', // 问答名字
      askContent: '', //问答内容
      value: '', // 文本输入
      bookList: [], // 文章列表
      pageSize: 5,
      pageNum: 1,
      total: 0,
      styleId: '', // 文章选择
      classList: [], // 班级列表
      classId: '', // 班级选择
      listData: [], // 问题列表
      listData: []
    }
  },
  methods: {
    goHistory () { // 返回上一级
      this.$router.go(-1)
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getQuestionList()
    },
    goLookAsk (item) { // 查看更多
      this.lookMore = true
      // this.lookMoreMes = item
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getAskReplyPageByAskId',
        body: { id: item }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.lookMoreMes = res.resultData
        }
      })
    },
    askForProfession () { // 求助专家
      this.zhuanjiaModal = true
    },
    handleBook (val) { // 选择书籍
      this.styleId = val
      this.getQuestionList()
    },
    handleClass (val) { // 选择班级
      //console.log(val)
      this.classId = val
      this.getQuestionList()
    },
    answer (lookMoreMes) { // 查看全部问答
      this.answerModal = true
      this.answerMess = lookMoreMes
      //console.log(this.answerMess)
    },
    getBookLessonList () { // 获取书文章列表
      const bookId = localStorage.getItem('syzg-bookId')
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getBookLessonList',
        body: { bookId: bookId }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.bookList = res.resultData
        }
      })
    },
    getClassList () { // 获取班级列表
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherClassList',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.classList = res.resultData
        }
      })
    },
    getQuestionList () { // 问题列表
      const param = {
        styleId: this.styleId, //styleId动态选择
        classId: this.classId,
        userId: this.$getUserInfo().id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherSolved',
        body: param
      }).done(res => {
        this.loading = false
        if (res && res.success && res.resultCode === 0) {
          if (res.resultData) {
            this.listData = res.resultData.list
            this.total = res.resultData.total
          } else {
            this.listData = []
          }
        }
      })
    },
    teacherReplay (answerMess) { //老师确定问答回复
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        userId: this.$getUserInfo().id,//用户id
        bookId: bookId,//书id
        styleId: answerMess.styleId,//课id
        recuserId: answerMess.userId,//被回复人id
        replyContent: this.value,//回复内容
        rootId: answerMess.id,//问题id
        parentId: answerMess.id//上级id
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/saveTeacherReply',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('回复成功')
          this.answerModal = false
          this.getQuestionList()
          this.value = ''
        }
      })
    }
  },
  mounted () {
    this.getBookLessonList()
    this.getClassList()
    this.getQuestionList()
  }
}
</script>
<style lang="less" scoped>
ul,
li,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}
.question {
  position: relative;
  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .top {
    //height: 110px;
   // background-color: #fff;
    position: relative;
    padding: 0 30px;

    .breadcrumb{
      margin: 20px auto ;
      //width: 1200px;
    }
    .goHistory {
      width: 16px;
      height: 32px;
      cursor: pointer;
    }
    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }
    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 100px;
      color: #9d9292;
      font-size: 24px;
    }
    .button {
      position: absolute;
      width: 180px;
      height: 45px;
      background-color: #e8f8f3;
      text-align: center;
      line-height: 44px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #22c190;
      top: 50%;
      right: 50px;
      margin-top: -20px;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    background: #f6f6f6;
    //padding-top: 30px;
    .contMes {
      //width: 1240px;
      background: #fff;
      margin: 0 auto;
      padding: 20px 50px;
      border-radius: 8px;
      .questionSolve {
        text-align: right;
        width: 120px;
        height: 32px;
        background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
        box-shadow: 0px 2px 8px 0px #dbcebc;
        border-radius: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        margin-left: auto;
      }
    }
    .mesList {
      //width: 1140px;
      margin: 0 auto;
      background: #f6f6f6;
      margin-top: 20px;
      border-radius: 8px;
    }
  }
}
.prepare {
  padding: 20px;
  .bookName {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #9d9292;
  }
  .bookTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 0px;
    color: #000000;
    margin: 10px 0px;
  }
  .photoImg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .userName {
    font-size: 18px;
    color: #000;
    line-height: 26px;
  }
  .fuhao {
    font-size: 18px;
    color: #9d9292;
    margin-left: 0px;
    line-height: 26px;
  }
  .userSchool {
    font-size: 18px;
    color: #9d9292;
    margin-left: 10px;
    line-height: 26px;
  }
  .questionText {
    font-size: 20px;
    line-height: 30px;
    color: #040506;
  }
  .date {
    color: #9d9292;
    font-size: 14px;
  }
  .forAsk {
    text-align: right;
    height: 30px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: @primary-color;
    cursor: pointer;
  }
}
.ulList {
  margin-top: 10px;
  .listMes {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #9d9292;
    height: 30px;
    line-height: 30px;
  }
}
.askHelp {
  height: 60px;
  width: 100%;
  background: #fff;
  .ask {
    width: 120px;
    height: 32px;
    background-color: @primary-color;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-top: 14px;
  }
  .help {
    width: 120px;
    height: 32px;
    background-color: #a3af90;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-left: 20px;
    margin-top: 14px;
  }
}
.mesMore {
  min-height: 160px;
  padding: 20px;
  background: #f6f6f6;
}
.footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.answerMes {
  .answerText {
    font-size: 16px;
    color: #9d9292;
  }
  .answerName {
    color: @primary-color;
    font-size: 18px;
    margin-left: 20px;
  }
  .answerTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #000000;
    margin-top: 10px;
  }
  .answerBgc {
    margin-top: 10px;
    background-color: #f6f6f6;
  }
  /deep/.ant-input {
    background-color: #f6f6f6;
  }
}
.zjcontent {
  padding: 20px;
  .title {
    height: 50px;
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #db5647;
    text-align: center;
  }
  .proplem {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #040506;
    text-align: center;
    .name {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: @primary-color;
    }
  }
  .zjFooter {
    text-align: center;
    margin-top: 10px;
    .cancle {
      width: 160px;
      height: 30px;
      background: #f6f6f6;
      color: #9d9292;
      font-size: 18px;
    }
    .sure {
      width: 160px;
      height: 30px;
      background: #f6f6f6;
      background-color: @primary-color;
      font-size: 18px;
      color: #fff;
      margin-left: 30px;
    }
  }
}
/deep/.ant-modal-header {
  border-bottom: none;
}
/deep/.ant-modal-title {
  font-size: 24px;
  color: #000000;
}
/deep/.ant-list-pagination {
  text-align: center;
  margin-top: 0px;
  background: #fff;
}
/deep/.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}
/deep/.ant-list-split .ant-list-item {
  border-bottom: none;
}
/deep/.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border-bottom: none;
}
/deep/.ant-list-lg .ant-list-item {
  padding: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 0px;
}
</style>
